module.exports = __webpack_public_path__ + "static/max-lucado.e5ba39f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/max-lucado.jpg
// module id = 1314
// module chunks = 168707334958949